import FieldConfig from "../../../proto/field-config"
import FieldViewForUser_PopoverMenu from "./components/popover/popover";
import FieldDropdown_PopoverOptionUser from "../../../generic/dropdown/components/option/option-user";
import FieldViewForUser_PopoverMenuMore from "./components/popover/popover-menu-more";
import UserManager from "../../../../manager/user-manager/user-manager";
import FieldUser from "../../../generic/user/user";
import FieldViewForUser_ControlView from "./render/control-view";
import FieldViewForUser_ControlViewNotEmpty from "./components/control-view/value-not-empty";
import FieldViewForUser_ControlViewEmpty from "./components/control-view/value-empty";

export default class FieldViewForUser extends FieldUser {

    constructor(config:FieldConfig) {
        super(config);

        this.options                        = this.getOptions() || []

        this.noValueOption                  = false
        this.isSearchable                   = true

        this.showMenuMore                   = true

        this.components.PopoverMenu         = FieldViewForUser_PopoverMenu
        this.components.PopoverOption       = FieldDropdown_PopoverOptionUser
        this.components.PopoverMenuMore     = FieldViewForUser_PopoverMenuMore

        this.components.ControlViewEmpty    = FieldViewForUser_ControlViewEmpty
        this.components.ControlViewNotEmpty = FieldViewForUser_ControlViewNotEmpty

        this.renderComponents.controlView   = FieldViewForUser_ControlView

    }

    getOptions() {
        const userManager = new UserManager();
        const userIds = userManager.getManagerForUsersIds(gd.companyId);

        return userIds.map((id: ID)=>{

            return {
                icon    : "",
                value   : id,
                label   : gd.session.users.get(id)!.name
            }
        })
    }

}
